import { BaseQuantity } from "../../interface/functionalityInterface";

export const Energy: BaseQuantity = {
  id: "001energy",
  name: "energy",
  type: "numeric",
  value: "",
  symbol: "E",
  baseUnit: "J",
  selectedUnit: "J",
  units: [
    { name: "J", fromConst: 1, toConst: 1 },
    { name: "kJ", fromConst: 1000, toConst: 1 / 1000 },
    { name: "Wh", fromConst: 3600, toConst: 1 / 3600 },
    { name: "kWh", fromConst: 3600 * 1000, toConst: 1 / 3600 / 1000 },
  ],
};
